import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";

export const TESTI_DEF = {
  soll_titolo: "Promemoria di inizio turno",
  soll_testo: "{nome}, il tuo turno è iniziato da più di {minuti} minuti e mancano ancora queste cose:",
  fine_titolo: "Il turno sta per finire",
  fine_testo: "Il turno di {turno} finisce alle {ora}. Restano ancora da fare:",
  inizio_titolo: "Lasciato dal turno precedente",
  inizio_testo: "Il turno di {turno} ha lasciato queste cose non fatte:",
};
export const testo = (cfg, k, vars) => Object.entries(vars || {}).reduce((s, [a, b]) => s.split(`{${a}}`).join(b ?? ""), (cfg && cfg[k]) || TESTI_DEF[k]);

const TONI = { amber: ["text-amber-700", "border-amber-300 bg-amber-50 text-amber-900"], red: ["text-red-700", "border-red-200 bg-red-50"] };

export function PopupAvviso({ open, onClose, tono = "amber", Icon, titolo, descr, voci, onVai, testid }) {
  const [tt, box] = TONI[tono];
  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="max-w-md" data-testid={testid}>
        <DialogHeader>
          <DialogTitle className={`flex items-center gap-2 ${tt}`}>{Icon && <Icon size={20} />} {titolo}</DialogTitle>
          <DialogDescription data-testid={`${testid}-desc`}>{descr}</DialogDescription>
        </DialogHeader>
        <div className="space-y-1.5 max-h-[50vh] overflow-y-auto">
          {voci.map((v) => (
            <div key={v.key} className={`flex items-center gap-2 rounded-lg border px-3 py-2 ${box}`} data-testid={`${testid}-voce-${v.key}`}>
              <span className="flex-1 text-sm font-semibold">{v.label}</span>
              {v.count != null && <b className="tabnum text-sm">{v.count}</b>}
              <Button size="sm" variant={v.count != null ? "outline" : "default"} onClick={() => onVai(v)} data-testid={`${testid}-vai-${v.key}`}>Vai</Button>
            </div>
          ))}
        </div>
        <DialogFooter><Button variant="outline" onClick={onClose} data-testid={`${testid}-ok`}>Ho capito</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
